var app = angular.module("leonardo");

var ReportsWorkOrders = function ($scope, $rootScope, $controller, $filter, ngDialog, ReportService, PropertyService,
                                  FilterService, AttachmentService, TemplateService, TaskService, $stateParams, $timeout) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $stateParams.reportTitle || $filter('translate')('Work Orders Reports');
  $scope.report_type = $stateParams.reportType || ReportService.TYPE_WORK_ORDERS;
  $scope.reportService = ReportService;

  $scope.fieldsReport = ReportService.fieldsReportWorkOrder;

  $scope.resetFields = function () {
    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    } else {
      $scope.fields_active = ['pms_external_id', 'property', 'unit', 'tenant_code', 'status', 'category', 'priority',
    'brief_description', 'requester_name', 'submitted_date', 'due_date', 'completed_date', 'completed_by', 'notes'];
    }

    if (FilterService.getFilter('group_by') === 'account') {
      if (!_.contains($scope.fields_active, 'property')) {
        $scope.fields_active.unshift('property');
      }
      if (!_.contains($scope.fields_active, 'portfolio')) {
        $scope.fields_active.unshift('portfolio');
      }
    }
    if ((FilterService.getFilter('group_by') === 'portfolio') || FilterService.getFilter('group_by') === 'group') {
      if (!_.contains($scope.fields_active, 'property')) {
        $scope.fields_active.unshift('property');
      }
    }
  };

  $scope.hasImportants = function (item) {
    var has = false;
    angular.forEach(item.notes, function (note) {
      if (note.important) {
        has = true;
      }
    });
    return has;
  };

  $scope.getDevice = function (type) {
    if (!isNull(type)) {
      switch (type.toString()) {
        case TaskService.DEVICE_TYPE_DESKTOP:
          return 'icon-computer.svg';
        case TaskService.DEVICE_TYPE_IOS:
          return 'icon-apple.svg';
        case TaskService.DEVICE_TYPE_ANDROID:
          return 'icon-android.svg';
      }
    }
    return 'icon-computer.svg';
  };

  $scope.getFieldValue = function (report, field) {
    var html = '';
    switch (field) {
      case 'name':
        return report.name;
      case 'type':
        return $filter('workOrderType')(report.type);
      case 'due_date':
      case 'modified':
      case 'service_request_date':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (date) {
            html += '<span class="date-multi">' + moment(date).format('MMM DD, YYYY, hh:mm a') + '</span>';
          });
        } else if (report[field]) {
          html = moment(report[field]).format('MMM DD, YYYY, hh:mm a');
        }
        return html;
      case 'enter_date':
        html = '';
        if (!isNull(report.pms_extra_fields) && !isNull(report.pms_extra_fields[field])) {
          html = angular.isObject(report.pms_extra_fields[field]) ? report.pms_extra_fields[field].name : moment(report.pms_extra_fields[field]).format('MMM DD, YYYY'); 
        }
        return html;
      case 'real_start':
      case 'real_finish':
      case 'scheduled_start':
      case 'scheduled_finish':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (date) {
            html += '<span class="date-multi">' + moment(date).format('MMM DD, YYYY HH:mm') + '</span>';
          });
        } else if (report[field]) {
          html = moment(report[field]).format('MMM DD, YYYY HH:mm');
        }
        return html;
      case 'completed_date':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (date) {
            var completed_date_aux = date.split('.');
            html += '<span class="date-multi">' + moment(completed_date_aux[0]).format('MMM DD, YYYY') + '</span>';
          });
        } else if (report[field]) {
          var completed_date_aux1 = report[field].split('T');
          html = moment(completed_date_aux1[0]).format('MMM DD, YYYY');
        }
        return html;
      case 'submitted_date':
        html = '';
        if (angular.isArray(report.submitted_date)) {
          angular.forEach(report.submitted_date, function (date) {
            var submitted_date_aux = date.split('.');
            html += '<span class="date-multi">' + moment(submitted_date_aux[0]).format('MMM DD, YYYY') + '</span>';
          });
        } else if (report.submitted_date) {
          var submitted_date_aux1 = report.submitted_date.split('T');
          html = moment(submitted_date_aux1[0]).format('MMM DD, YYYY');
        }
        return html;
      case 'notes':
        html = '';
        angular.forEach(report.notes, function (note) {
          html += '<span>' + '* ' + note.text + ' (' + moment(note.created).format("MMM DD, YYYY") + ').' + '</span>';
        });
        return html;
      case 'cannot_do_notes':
        html = '';
        angular.forEach(report.notes, function (note) {
          if (note.action_item_status == ReportService.STATUS_CANNOT_DO) {
            html += '<span>' + '* ' + note.text + ' (' + moment(note.created).format("MMM DD, YYYY") + ').' + '</span>';
          }
        });
        return html;
      case 'note_add_by':
        html = '';
        angular.forEach(report.notes, function (note) {
          if (note.account_user) {
            html += '<span>' + $filter("username")(note.account_user.user) + '</span>';
          }
        });
        return html;
      case 'account_users_assigned':
        html = '';
        angular.forEach(report.account_users_assigned, function (account_user) {
          html += '<span>' + $filter("username")(account_user.user) + '</span>';
        });
        return html;
      case 'completed_by':
        html = '';
        if (angular.isArray(report.completed_by)) {
          angular.forEach(report.completed_by, function (account_user) {
            html += '<span>' + account_user + '</span>';
          });
        } else if (report.completed_by) {
          html = '<span>' + report.completed_by + '</span>';
        }
        return html;
      case 'notes_important':
        return $scope.hasImportants(report) ? 'YES' : '';
      case 'notes_attachments':
        html = '';
        angular.forEach(report.notes, function (note) {
          angular.forEach(note.attachments, function (attachment) {
            html += getAttachemnthtml(attachment);
          });
        });
        return html;
      case 'attachments':
        html = '';
        angular.forEach(report.attachments, function (attachment) {
          html += getAttachemnthtml(attachment);
        });
        return html;
      case 'completed_on_device':
        html = '<icon class="icon-device icon" icon-image="' + $scope.getDevice(report.completed_on_device) + '" icon-color="secondaryColor" icon-width="15" icon-height="15"></icon>';
        if (report.completed_on_device == TaskService.DEVICE_TYPE_DESKTOP) {
          html += '<span class="device-name">desktop</span>';
        } else if (report.completed_on_device == TaskService.DEVICE_TYPE_IOS) {
          html += '<span class="device-name">ios</span>';
        } else if (report.completed_on_device == TaskService.DEVICE_TYPE_ANDROID) {
          html += '<span class="device-name">android</span>';
        }
        return html;
      case 'completed_position':
        html = '';
        if (report.completed_position) {
          html += '<a href="https://www.google.com/maps/search/?api=1&query=' + report.completed_position.lat + ',' + report.completed_position.lon + '" target="_blank">' + report.completed_position.lat + ', ' + report.completed_position.lon + '</a>';
        }
        return html;
      case 'marked_dismiss':
        if (report.status) {
          return report.status === ReportService.STATUS_DISMISS ? 'YES' : '';
        } else {
          return '';
        }
      case 'cannot_do':
        if (report.status) {
          return report.status === ReportService.STATUS_CANNOT_DO ? 'YES' : '';
        } else {
          html = '';
          if (angular.isArray(report.cannot_do_date)) {
            angular.forEach(report.cannot_do_date, function (date) {
              html += '<span>' + moment(date).format('MMM DD, YYYY') + '</span>';
            });
          } else if (report.cannot_do_date) {
            html = moment(report.cannot_do_date).format('MMM DD, YYYY');
          }
          return html;
        }
      case 'dynamic_form':
        html = '';
        if (report.dynamic_form_data) {
          if (!angular.isArray(report.dynamic_form_data)) {
            html = '<span class="link" ng-click="openDynamicFormDialog(report)">' + report.dynamic_form_data.dynamic_form.name + '</span>';
          } else {
            angular.forEach(report.dynamic_form_data, function (dynamic_form_data) {
              html += '<span class="link" ng-click="openDynamicFormDialog(report, ' + dynamic_form_data.id + ')">' + dynamic_form_data.dynamic_form.name + '</span>';
            });
          }
        }
        return html;
      case 'account':
      case 'portfolio':
      case 'property':
        return report[field] ? report[field].name : '';
      case 'groups':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (element) {
            html += `<span>${element[1]}</span>`;
          });
        }
        return html;
      case 'managed_by':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (element) {
            html += '<span>' + element.name + '</span>';
          });
          return html;
        }
        else {
          if (report[field]) {
            html = report[field].name;
            return html;
          }
          html = (field === 'managed_by') ? 'Only Owner' : ''
          return html
        }
      case 'has_permission_to_enter':
      case 'tenant_caused':
        return report[field] ? 'YES' : 'NO';
      default:
        if (!isNull(report.pms_extra_fields) && !isNull(report.pms_extra_fields[field])) {
          return angular.isObject(report.pms_extra_fields[field]) ? report.pms_extra_fields[field].name : report.pms_extra_fields[field];
        }
        return report[field];
    }
  };

  function getAttachemnthtml(attachment) {
    var htmlelement = '';
    attachment.file = attachment.document_file ? attachment.document_file.signed_view_url : (attachment.signed_view_url || attachment.file);
    var href = attachment.link ? attachment.link : attachment.file;
    if (AttachmentService.getClassesAttachment(attachment) === 'folder') {
      htmlelement += '<span><a ui-sref="documents.list({pk:' + attachment.document_folder.id + '})" target="_blank">';
    } else {
      htmlelement += '<span><a href="' + href + '" target="_blank">';
    }
    if (AttachmentService.getClassesAttachment(attachment) === 'folder') {
      htmlelement += '<icon class="icon" icon-image="icon-folder.svg" icon-width="18" icon-height="18" icon-color="secondaryColor"></icon>';
    }
    if (AttachmentService.getClassesAttachment(attachment) === 'image') {
      htmlelement += '<img src="' + href + '"/>';
    } else {
      htmlelement += attachment.name;
    }
    htmlelement += '</a></span>';
    return htmlelement;
  }

  $scope.openDynamicFormDialog = function (report, dynamic_form_data_id) {
    PropertyService.get(report.property.id).then(function (property) {
      if (dynamic_form_data_id) {
        angular.forEach(report.dynamic_form_data, function (data) {
          if (data.id == dynamic_form_data_id) {
            ngDialog.openConfirm({
              template: 'views/templates/dialog/task/dynamic-form-react.html',
              controller: 'TaskDynamicFormDialogReact',
              className: 'ngdialog-theme-default ngdialog-dynamic-form',
              resolve: {
                formObj: [function () {
                  return data.dynamic_form;
                }],
                formDataObj: ['DynamicFormDataRestService', function (DynamicFormDataRestService) {
                  return DynamicFormDataRestService.one(data.id).get();
                }]
              },
              data: {
                task: report,
                approvalStatus: false,
                property: property,
                mode: 'read',
                print: true,
              }
            }).then(function (result) {
              callback(result);
            });
          }
        });
      } else {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/task/dynamic-form-react.html',
          controller: 'TaskDynamicFormDialogReact',
          className: 'ngdialog-theme-default ngdialog-dynamic-form',
          resolve: {
            formObj: [function () {
              return report.dynamic_form_data.dynamic_form;
            }],
            formDataObj: ['DynamicFormDataRestService', function (DynamicFormDataRestService) {
              return DynamicFormDataRestService.one(report.dynamic_form_data.id).get();
            }]
          },
          data: {
            task: report,
            approvalStatus: false,
            property: property,
            mode: 'read',
            print: true,
          }
        }).then(function (result) {
          callback(result);
        });
      }
    });
  };

  $scope.getFieldClasses = function (field) {
    var classes = [];
    switch (field) {
      case 'name':
        classes.push('field-name');
        break;
      case 'notes':
      case 'cannot_do_notes':
        classes.push('field-note');
        break;
      case 'note_add_by':
        classes.push('field-note-user');
        break;
      case 'users':
        classes.push('field-note-user');
        break;
      case 'attachments':
      case 'notes_attachments':
        classes.push('field-media');
        break;
      case 'due_date':
      case 'completed_date':
        classes.push('date-multi-head');
        break;
    }
    return classes;
  };

  $scope.groupReports = function (data) {
    if (data.results) {
      $scope.reports = data.results.data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    } else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];

    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({ id: account.id, name: account.name });
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({ id: portfolio.id, name: portfolio.name });
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({ id: property.id, name: property.name });
          }
        });
        break;
    }
    var fieldsReport = $scope.fieldsReport.map(item => item.id);
    angular.forEach($scope.reports, function (value) {
      if ($scope.fields_active.includes('attachments')) {
        value.attachmentObjects = [];
        angular.forEach(value.notes, function (note) {
          angular.forEach(note.attachments, function (attachment) {
            value.attachmentObjects.push(attachment);
          });
        });
      }

      if (value.pms_extra_fields) {
        angular.forEach(Object.keys(value.pms_extra_fields), function (key) {
          if (!['work_order', 'pms_platform'].includes(key) && !fieldsReport.includes(key)) {
            var name_cap = capitalize(key);
            $scope.fieldsReport.push({ id: key, name: name_cap });
            fieldsReport.push(key);
          }
        });
      }

      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          } else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          } else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          } else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              updateWorkOrderGroupCase(group, id, name, array_by_name);
            });
          } else if (value.property && value.property.groups && (value.property.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.property.groups, function (group) {
              updateWorkOrderGroupCase(group, id, name, array_by_name);
            });
          } else if (value.portfolio && value.portfolio.groups && (value.portfolio.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.portfolio.groups, function (group) {
              updateWorkOrderGroupCase(group, id, name, array_by_name);
            });
          } else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)) {
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({ id: manager.id, name: manager.name });
              });
            } else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({ id: id, name: name });
            }
          } else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({ id: id, name: name });
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({ id: value_manager.id, name: value_manager.name, reports: [] });
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports, value.id) < 0) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
          }
        });
      } else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({ id: id, name: name, reports: [] });
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].reports, value.id) < 0) {
          $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        }
      }

    });
    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    } else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
    $rootScope.$broadcast('fields-report:updated', $scope.fieldsReport);
  };

  function updateWorkOrderGroupCase(group, id, name, array_by_name) {
    if (FilterService.hasFilter('group_reports')) {
      if (_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())) {
        id.push(group.id);
        name.push(group.name);
        array_by_name.push({ id: group.id, name: group.name });
      }
    } else {
      id.push(group.id);
      name.push(group.name);
      array_by_name.push({ id: group.id, name: group.name });
    }
  }

  $scope.toggleTemplate = function(template, event) {
    angular.element('body').addClass('block-ui-visible');
    angular.element('body').addClass('block-ui-active');
    $timeout(function() {
      $scope.templateExpanded = ($scope.templateExpanded == template) ? null : template;
      angular.element('body').removeClass('block-ui-visible');
      angular.element('body').removeClass('block-ui-active');
      $timeout(function() {
        angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: angular.element(event.target).offset().top - 120}, "slow");
      }, 0);
    }, 0);
  };

  $scope.templateIsExpanded = function(template) {
    return $scope.templateExpanded == template;
  };
  
};

app.controller('ReportsWorkOrders', ['$scope', '$rootScope', '$controller', '$filter', 'ngDialog', 'ReportService',
  'PropertyService', 'FilterService', 'AttachmentService', 'TemplateService', 'TaskService', '$stateParams', '$timeout', ReportsWorkOrders]);
